
export default {
  handle: function (vm, response, callBackWhenRecover) {
    // ------ case1:超时 ------
    if (response.statusText === 'timeout') {
      vm.$alert('请求超时，请您重新发送该请求', '错误')
      return
    } else {
      // continue
    }
    // ------ ↓vue-resource超时判断↓ ------
    // 注：vue-resource的超时没有明确回执，回执状态码0、是其内部状态默认值、并不能确保它一定表示超时
    if (response.status === 0) {
      console.error('vue-resource请求超时，并不能确保是请求超时，具体回执如下：')
      vm.$alert('请求超时，请您重新发送该请求', '错误')
      return
    }
    // ------ ↑vue-resource超时判断↑ ------
    // ------ case3:后台异常 ------
    switch (response.status) {
    // 401：未登录
      case 401:
        var loginFrame = document.getElementById('loginFrame')
        if (loginFrame == null) {
          loginFrame = document.createElement('iframe')
          loginFrame.setAttribute('id', 'loginFrame')
          loginFrame.style.position = 'absolute'
          loginFrame.style.boxSizing = 'border-box'
          loginFrame.style.width = window.top.innerWidth + 'px'
          loginFrame.style.height = window.top.innerHeight + 'px'
          loginFrame.style.top = '0'
          loginFrame.style.left = '0'
          loginFrame.style.zIndex = '9999'
          document.body.appendChild(loginFrame)
          // 调用后台
          vm.$http({method: 'GET', url: 'rest/sysInfo/getLoginUrl'}).then(response => {
            loginFrame.src = response.bodyText
          }, response => {
            // 提示
            vm.$notify({type: 'error', message: '获取登录地址失败', position: 'bottom-right'})
          })
        }
        window.loginFrame = loginFrame
        break
    // 403：访问指定功能时权限不足
      case 403:
        return vm.$alert('对不起，您没有权限进行该操作', '错误', {type: 'error', customClass: 'global-exception-alert'})
    // 404：未找到页面或功能
      case 404:
        return vm.$alert('服务器不存在的页面或功能方法', '404', {type: 'error', customClass: 'global-exception-alert'})
    // 500：服务器异常
      case 500:
        if (response.body instanceof ArrayBuffer) {
          let fileReader = new FileReader()
          fileReader.readAsText(new Blob([response.body]), 'utf-8')
          fileReader.onload = function () { vm.$baize.showExceptionMsg(vm, JSON.parse(fileReader.result)) }
        } else {
          vm.$baize.showExceptionMsg(vm, response.body)
        }
        break
    // 631：业务异常（自定义）
      case 631:
        if (response.body instanceof ArrayBuffer) {
          let fileReader = new FileReader()
          fileReader.readAsText(new Blob([response.body]), 'utf-8')
          fileReader.onload = function () { return vm.$alert(fileReader.result, '提示', {type: 'warning'}) }
        } else {
          return vm.$alert(response.body, '提示', {type: 'warning'})
        }
        break
    // 632：校验异常（自定义）
      case 632:
        vm.$baize.showValidationMsg(vm, response.body)
        break
    // 其他
      default:
        console.log(response.body, '错误' + '(' + response.status + ',未识别异常)')
        return vm.$alert(response.body, '错误' + '(' + response.status + ',未识别异常)', {type: 'error', customClass: 'global-exception-alert'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/baize/src/ExceptionHandler.js